export const translations = {
  ro: {
    eyebrow: 'Academia ta de șah',
    heroHeadline: ['Mai mult decât', 'un joc.', 'O mentalitate', 'de învingător.'],
    heroSub: 'Tehnica jocului, psihologia victoriei și reziliența mentală — totul într-un singur loc.',
    btnPrimary: 'Explorează academia',
    aboutLabel: 'Citește povestea noastră',
    videoTagline: ['Stăpânește tabla. ', 'Stăpânește-ți mintea.'],
    drawerTitle: ['De ce ', 'ChessMindset', '?'],
    drawerP1: 'La ChessMindset.academy, credem că tabla de șah este oglinda caracterului tău. Șahul nu este doar despre memorarea unor deschideri complexe, ci despre cum reacționezi sub presiune, cum gestionezi eșecul și cât de strategic îți planifici următoarea victorie.',
    drawerP2: 'Misiunea noastră? Să transformăm jucătorii amatori în strategi lucizi. Îți oferim instrumentele tehnice pentru a crește în ELO, dar mai ales, îți antrenăm reziliența psihologică necesară pentru a domina atât tabla de joc, cât și provocările de zi cu zi.',
    drawerP3: 'Nu suntem doar o școală de șah. Suntem laboratorul unde îți construiești disciplina, răbdarea și curajul. Învață să gândești cu trei mutări înainte.',
    sectionLabel: 'Ce oferim',
    sectionTitle: ['Transformă-ți jocul,', 'transformă-ți mintea'],
    features: [
      {
        icon: '♔',
        title: 'The Academy',
        desc: 'Cursuri video structurate pe module: Deschideri, Tactică, Finaluri. Învață de la fundament la strategie avansată.',
        btn: 'Explorează cursurile →'
      },
      {
        icon: '🧠',
        title: 'Mindset Hub',
        desc: 'Articole și eseuri despre psihologia victoriei, reziliență și gestionarea eșecului. Dezvoltă mentalitatea unui campion.',
        btn: 'Citește articolele →'
      },
      {
        icon: '♟️',
        title: 'Daily Puzzle',
        desc: 'Problema zilei pentru a-ți păstra mintea ascuțită. Integrat cu Lichess API pentru varietate și provocare constantă.',
        btn: 'Rezolvă puzzle-ul →'
      },
      {
        icon: '👥',
        title: 'Community',
        desc: 'Forum și Discord unde membrii își analizează partidele împreună. Învață din experiența altora și construiește conexiuni.',
        btn: 'Alătură-te comunității →'
      }
    ],
    footerText: 'Șahul nu are vârstă, dar strategia ta are nevoie de un plan. Construiește-ți mindset-ul de învingător la orice etapă a vieții.',
    footerPrivacy: 'Politica de confidențialitate',
    footerCookies: 'Politica de cookie-uri',
    footerTerms: 'Termeni și condiții',
    footerRefund: 'Politica de rambursare',
    footerPricing: 'Prețuri',
    cookieBannerTitle: 'Preferințe cookie',
    cookieBannerText: 'Folosim cookie-uri necesare pentru funcționare și cookie-uri opționale pentru analiză/marketing. Alege ce permiți.',
    cookieNecessary: 'Cookie-uri necesare (mereu active)',
    cookieAnalytics: 'Cookie-uri de analiză',
    cookieMarketing: 'Cookie-uri de marketing',
    cookieAccept: 'Acceptă',
    cookieReject: 'Refuză',
    cookiePrefs: 'Preferințe',
    cookieSavePrefs: 'Salvează preferințe',
    footerCopy: '© 2026 ChessMindset.academy. Toate drepturile rezervate.'
  },
  en: {
    eyebrow: 'Your chess academy',
    heroHeadline: ['More than', 'a game.', 'A winner\'s', 'mindset.'],
    heroSub: 'Game technique, the psychology of winning, and mental resilience — all in one place.',
    btnPrimary: 'Explore Academy',
    aboutLabel: 'Read our story',
    videoTagline: ['Master the board. ', 'Master your mind.'],
    drawerTitle: ['Why ', 'ChessMindset', '?'],
    drawerP1: 'At ChessMindset.academy, we believe the chessboard is a mirror of your character. Chess is not just about memorizing complex openings, but about how you react under pressure, how you handle failure, and how strategically you plan your next victory.',
    drawerP2: 'Our mission? To transform amateur players into lucid strategists. We provide you with the technical tools to grow in ELO, but more importantly, we train the psychological resilience needed to dominate both the game board and daily challenges.',
    drawerP3: 'We are not just a chess school. We are the laboratory where you build discipline, patience, and courage. Learn to think three moves ahead.',
    sectionLabel: 'What we offer',
    sectionTitle: ['Transform your game,', 'transform your mind'],
    features: [
      {
        icon: '♔',
        title: 'The Academy',
        desc: 'Structured video courses by module: Openings, Tactics, Endgames. Learn from fundamentals to advanced strategy.',
        btn: 'Explore Courses →'
      },
      {
        icon: '🧠',
        title: 'Mindset Hub',
        desc: 'Articles and essays about the psychology of winning, resilience, and failure management. Develop a champion\'s mindset.',
        btn: 'Read Articles →'
      },
      {
        icon: '♟️',
        title: 'Daily Puzzle',
        desc: 'Daily problem to keep your mind sharp. Integrated with Lichess API for variety and constant challenge.',
        btn: 'Solve Puzzle →'
      },
      {
        icon: '👥',
        title: 'Community',
        desc: 'Forum and Discord where members analyze games together. Learn from others\' experience and build connections.',
        btn: 'Join Community →'
      }
    ],
    footerText: 'Chess is ageless, but your strategy needs a plan. Build your winning mindset at any stage of life.',
    footerPrivacy: 'Privacy Policy',
    footerCookies: 'Cookie Policy',
    footerTerms: 'Terms & Conditions',
    footerRefund: 'Refund Policy',
    footerPricing: 'Pricing',
    cookieBannerTitle: 'Cookie preferences',
    cookieBannerText: 'We use necessary cookies for core functionality and optional cookies for analytics/marketing. Choose what you allow.',
    cookieNecessary: 'Necessary cookies (always active)',
    cookieAnalytics: 'Analytics cookies',
    cookieMarketing: 'Marketing cookies',
    cookieAccept: 'Accept',
    cookieReject: 'Reject',
    cookiePrefs: 'Preferences',
    cookieSavePrefs: 'Save preferences',
    footerCopy: '© 2026 ChessMindset.academy. All rights reserved.'
  }
};
